import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../baseComponents/PermissionChecker/function'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { TableComponentProps } from '../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { ColumnTableSchema } from '../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { CustomRenderBoolean, CustomRenderLanguageName, DeleteRow, EditRow } from '../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import TwinTable from '../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../baseComponents/TwinTable/BaseScreenTable'
import { CsvOrderTemplateModelType } from '@teinor/erp/types/company/config/csvOrderTemplate'
import ModalCECsvOrderTemplate from './ModalCECsvOrderTemplate'
import ModalDeleteCsvOrderTemplate from './ModalDeleteCsvOrderTemplate'
interface ConfigCsvOrderTemplatesProps extends ComponentWithPermissions { }

const ConfigCsvOrderTemplates: React.FC<ConfigCsvOrderTemplatesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('exportTemplates', 'Plantillas exportación'),
        newText: t('newTemplate', 'Nueva plantilla'),
    }

    return (
        <BaseScreenTable TableComponent={TableCsvOrderTemplates} CreateModalComponent={ModalCECsvOrderTemplate} EditModalComponent={ModalCECsvOrderTemplate} pageData={pageData} userPermissions={userPermissions} DeleteModalComponent={ModalDeleteCsvOrderTemplate}/>
    )
}

interface TableCsvOrderTemplatesProps extends TableComponentProps { }

const TableCsvOrderTemplates: React.FC<TableCsvOrderTemplatesProps> = ({ userPermissions, setTableInstance, setOpened }) => {
    const { t } = useTwinTranslation()

    const columns: ColumnTableSchema<CsvOrderTemplateModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            width: 200,
            label: t('id', 'ID'),
            sortable: true,
        },
        {
            id: 'name',
            dataKey: 'name',
            width: 200,
            label: t('name', 'Nombre'),
            sortable: true,
        },
        {
            id: 'LangId',
            dataKey: 'LangId',
            label: t('language', 'Idioma'),
            customRender: (parameterValue) => <CustomRenderLanguageName languageId={parameterValue} />,
            generalSearchable: false
        },
        {
            id: 'is_main',
            dataKey: 'is_main',
            label: t('default', 'Por defecto'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={65} />,
            width: 120
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData, e) => { e.preventDefault(); e.stopPropagation(); setOpened({ type: 'edit', allRowData }) }} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable name='csvTemplates' columns={columns} getDataFrom='/api/app/config/csvOrderTemplate/getAllCsvOrderTemplates' setTableInstance={setTableInstance} />
    )
}

export default ConfigCsvOrderTemplates